import {
  Component,
  Input
} from '@angular/core';

import {
  ReactiveFormsModule, FormsModule 
} from '@angular/forms';

import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseFieldRenderer } from '../../../core/runtime/base/base-field-renderer';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select-renderer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormField, MatFormFieldModule, MatInputModule],
  templateUrl: './select-renderer.component.html'
})
export class SelectRendererComponent
extends BaseFieldRenderer {

  get options(): any[] {

    return this.field.options || [];
  }

}